import gql from 'graphql-tag';

export const sendCompanyInvitationMutation = gql`
  mutation sendCompanyInvitation($input: SendCompanyInvitationInput!) {
    sendCompanyInvitation(input: $input) {
      companyInvitation {
        companyInvitationId
        updatedAt
      }
    }
  }
`;
